import { render, staticRenderFns } from "./PreviewPartsContainerFollowButton.vue?vue&type=template&id=00782ff4&"
import script from "./PreviewPartsContainerFollowButton.vue?vue&type=script&lang=js&"
export * from "./PreviewPartsContainerFollowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports